import { createTheme } from '@mui/material/styles';

export const PG = {
  bg: '#0b1220',
  panel: '#121a2b',
  chat: '#0e1626',
  assistant: '#243044',
  user: '#1e3a8a',
  border: 'rgba(148,163,184,0.28)',
  text: '#f1f5ff',
  muted: '#c5d4ee',
  accent: '#38bdf8',
  preview: '#0a0f1a',
};

export const pgBtn = {
  textTransform: 'none' as const,
  fontWeight: 600,
  borderRadius: 1.5,
  px: 1.5,
  minHeight: 34,
};

export const playgroundMuiTheme = createTheme({
  palette: {
    mode: 'dark',
    primary: { main: PG.accent },
    secondary: { main: '#818cf8' },
    background: { default: PG.bg, paper: PG.panel },
    text: { primary: PG.text, secondary: PG.muted },
    divider: PG.border,
  },
  typography: {
    fontFamily: 'ui-sans-serif, system-ui, "Segoe UI", sans-serif',
  },
  components: {
    MuiInputLabel: {
      styleOverrides: { root: { color: PG.muted } },
    },
    MuiFormLabel: {
      styleOverrides: { root: { color: PG.muted } },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        notchedOutline: { borderColor: PG.border },
      },
    },
    MuiToggleButton: {
      styleOverrides: {
        root: { color: PG.muted, borderColor: PG.border },
      },
    },
  },
  zIndex: {
    modal: 1600,
    snackbar: 1650,
    tooltip: 1700,
  },
});
